import { AppConfigType } from './app-config.type';

const ReownConfig = {
  projectId: process.env.REACT_APP_PROJECT_ID,
};

export const AppConfig: AppConfigType = {
  apiUrl: process.env.REACT_APP_API_NEST_URL,
  appUrl: process.env.REACT_APP_APPLICATION_URL,
  isDev: process.env.REACT_APP_IS_DEV === 'true',
  routes: {
    airdrop: '/airdrop',
  },
  apiRoutes: {
    getUserProfile: () => '/user/profile',
    getPointsData: () => '/points',
    getAirdropData: () => '/points/airdrop-tokens',
    claim: () => '/points/airdrop-tokens/claimed',
    listMissions: () => '/mission/list',
    listQuests: () => '/quest/list',
    getReferralInvites: () => '/referral/invites',
    redeemReferralCode: () => '/referral/redeem',
    connectTwitter: () => '/twitter/connect',
    twitterLogin: () => '/twitter/login',
    listWithdraw: () => '/withdrawal/list',
    listUnstake: () => '/ozk/withdrawals/list',
    patchUnstake: () => '/ozk/withdrawals/:nonce',
    listTransaction: () => '/transaction/list',
    listToken: () => '/token/list',
  },
  reown: ReownConfig,
  telegramBotName: process.env.REACT_APP_TELEGRAM_BOT_NAME,
  l2GasLimit: 300000,
  l2GasLimitAsParam: 1500000,
  l1GasLimit: 2000000,
};
